import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import './ShareableBadge.css';

const ShareableBadge = ({ player, badge }) => {
  const badgeRef = useRef(null);

  const handleShare = async () => {
    try {
      // Generate image from the badge div
      const element = badgeRef.current;
      const canvas = await html2canvas(element, {
        backgroundColor: '#1a1a1a', // Dark background
        scale: 2, // Higher quality
      });

      // Convert canvas to blob
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      const file = new File([blob], 'badge.png', { type: 'image/png' });

      // Check if Web Share API is supported
      if (navigator.share) {
        await navigator.share({
          files: [file],
          title: `${player.name}'s Badge from Who Is Most Likely`,
          text: `Check out my badge: ${badge.title}!`
        });
      } else {
        // Fallback for browsers that don't support sharing
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'my-badge.png';
        link.click();
      }
    } catch (error) {
      console.error('Error sharing badge:', error);
      alert('Failed to share badge. Try downloading instead.');
    }
  };

  return (
    <div className="shareable-badge-container">
      <div ref={badgeRef} className="badge-content-container">
        <div className="badge-content">
          <div className="badge-header">
            <img src='/assets/logo.png' alt="WIML Logo" className="badge-logo" />
            <h4>Who Is Most Likely</h4>
          </div>
          <div className="badge-body">
            <h3>{player.name.toUpperCase()}</h3>
            <div className="badge-award">
              <h4>{badge.title}</h4>
              <p>{badge.description}</p>
            </div>
            <div className="badge-stats">
              <p>{player.totalVotesReceived} votes received</p>
            </div>
          </div>
        </div>
      </div>
      <button onClick={handleShare} className="share-button">
        Share on Instagram
      </button>
    </div>
  );
};

export default ShareableBadge;
